import type { JSX, ReactNode } from 'react';

export type AlertTone = 'error' | 'warning';

const toneClasses: Readonly<Record<AlertTone, string>> = {
  error: 'border-danger/40 bg-danger-soft text-danger',
  warning: 'border-warning/40 bg-warning-soft text-warning',
};

export interface AlertProps {
  readonly tone?: AlertTone;
  readonly children: ReactNode;
}

/** Something went wrong, said where it happened and announced to assistive technology. */
export function Alert({ tone = 'error', children }: AlertProps): JSX.Element {
  return (
    <p
      role="alert"
      className={`rounded-lg border px-3 py-2 text-sm font-medium ${toneClasses[tone]}`}
    >
      {children}
    </p>
  );
}
